import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const setAdminRole = async (userId, value) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/role/" + userId + "/" + value, { headers: AuthHeader.authHeader() });
    return response.data;
};

const setEmailPrefs = async (value) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/email/prefs", 
  { "prefs" : value }, 
  { headers: AuthHeader.authHeader()});
  return response.data;
};

const updateAddress = async (newAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/address/" + newAddress.id, 
    newAddress,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updateAddressForUser = async (newAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/address",
    newAddress,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const addAddressForUser = async (newAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/address/add",
    newAddress,
    { headers: AuthHeader.authHeader() }
  );
  return response.data.data;
}

const updateName = async (newName) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/name",
    newName,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updatePhone = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/phone",
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updateTitle = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/title",
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updateNhKExempt = async (userId, nhkExempt) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/nhk-exempt",
    { userId, nhkExempt },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const resetNhKWindow = async (userId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/nhk-reset",
    { userId },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const getUserTitles = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/user/titles",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const getAllCuratedTitles = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/super/titles",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const createCuratedTitle = async (title) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/super/titles",
    { title },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updateCuratedTitle = async (id, data) => {
  const response = await axios.put(process.env.REACT_APP_API_URL + "/admin/super/titles/" + id,
    { id, ...data },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const deleteCuratedTitle = async (id) => {
  const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/super/titles/" + id,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updateMyPhone = async (phone) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/phone",
    { phone: phone },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updateUsernameEmail = async (newName) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/username", 
    newName,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const updateBillingAddress = async (newAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/billingaddress", 
    newAddress,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const forgotPassword = async (emailAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/forgotpassword", 
    {emailAddress: emailAddress},
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const resetPassword = async (emailAddress, newPassword, confirmPassword, forgotId) => {
  console.log("resetPassword", emailAddress, newPassword, confirmPassword, forgotId);
  try {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/user/resetpassword", 
      {
        emailAddress: emailAddress,
        newPassword: newPassword,
        confirmNewPassword: confirmPassword,
        forgotId: forgotId
      },
      { headers: AuthHeader.authHeader() }
    );
    return response.data;
  } catch(err) {
    console.log(err);
    return err.response.data;
  }
}    

const sendUnregisteredEmailToAll = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/email/unregistered", { headers: AuthHeader.authHeader() });
    return response.data;
};

const sendUnregisteredEmail = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/email/unregistered/" + userId, { headers: AuthHeader.authHeader() });
    return response.data;
};

const deactivateUser = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/deactivate/" + userId, { headers: AuthHeader.authHeader() });
    if(response.error) {
      return response;
    }
    return response.data;
};

const reactivateUser = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/reactivate/" + userId, { headers: AuthHeader.authHeader() });
    if(response.error) {
      return response;
    }
    return response.data;
};

const submitContactUs = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/contactus", 
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};
const updateUserBalances = async (data, sendEmails = true, activationDate = null) => {
  const body = { users: data, sendEmails: sendEmails };
  if (activationDate) {
    body.activationDate = activationDate;
  }
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/bulk",
    body,
    { headers: AuthHeader.authHeader(), timeout: 60000 }
  );
  return response.data;
};

const getBulkUpdateJobStatus = async (jobId) => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/user/bulk/job/" + jobId,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getBulkUsersPage = async (page = 1, perPage = 100, search = '') => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/bulkusers", {
    headers: AuthHeader.authHeader(),
    params: {
      range: JSON.stringify([page, perPage]),
      ...(search ? { search } : {})
    },
    timeout: 60000
  });
  return { data: response.data?.data || [], count: parseInt(response.data?.count, 10) || 0 };
};

const getAddresses = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/user/addresses",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getAddressesForUser = async (userId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/user/" + userId + "/addresses",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const searchSubsiteUsers = async (search, limit = 10) => {
  const range = JSON.stringify([1, limit]);
  let url = process.env.REACT_APP_API_URL + "/admin/users?range=" + range;
  if (search && search.trim() !== '') {
    url += "&search=" + encodeURIComponent(search);
  }
  const response = await axios.get(url, { headers: AuthHeader.authHeader() });
  return response.data;
};

const addAddress = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/address", 
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const removeAddress = async (addressId) => {
  const response = await axios.delete(process.env.REACT_APP_API_URL + "/user/address/" + addressId, 
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const updateBalanceRollsOver = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/balanceRollsOver", 
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const getSubsiteAdmins = async (subsiteId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/admins/" + subsiteId, 
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getEmailHistory = async (userId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/user/emailhistory/" + userId, 
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getCapabilities = async () => {
  // Admin capabilities (ADD_USER, VIEW_SURVEY, etc.)
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/capabilities", 
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setCapabilities = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/capabilities",
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getProductCapabilities = async () => {
  // Product visibility capabilities (Supervisor, Tier_1, etc.)
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/product-capabilities",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setProductCapabilities = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/product-capabilities",
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getCapabilityDetails = async (capabilityId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/product-capabilities/" + capabilityId,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setCapabilityLogo = async (capabilityId, decorationLogoId, value) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/capability/logo",
    { capabilityId, decorationLogoId, value },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setCapabilityColor = async (capabilityId, colorId, value) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/capability/color",
    { capabilityId, colorId, value },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getCapabilityRestrictions = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/capability-restrictions",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

// Get/set capabilities for a specific decoration logo (supports multiple)
const getLogoCapability = async (decorationLogoId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/logo/" + decorationLogoId + "/capability",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setLogoCapability = async (decorationLogoId, capabilityIds) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/logo/capability",
    { decorationLogoId, capabilityIds },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

// Get/set capabilities for a specific color (supports multiple)
const getColorCapability = async (colorId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/color/" + colorId + "/capability",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setColorCapability = async (colorId, capabilityIds) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/color/capability",
    { colorId, capabilityIds },
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getUserSubsites = async (userId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/user/subsites/" + userId,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const searchAllUsers = async (range, search) => {
  let url = process.env.REACT_APP_API_URL + "/admin/super/users?range=" + JSON.stringify(range);
  if (search && search.trim() !== '') {
    url += "&search=" + encodeURIComponent(search);
  }
  const response = await axios.get(url,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getSuperUserDetails = async (userId, subsiteId) => {
  let url = process.env.REACT_APP_API_URL + "/admin/super/user/" + userId;
  if (subsiteId) {
    url += "?subsiteId=" + subsiteId;
  }
  const response = await axios.get(url,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getScheduledBalances = async (userId) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/user/scheduledbalances/" + userId,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const deleteScheduledBalance = async (id) => {
  const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/user/scheduledbalance/" + id,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const UserService = {
  setAdminRole,
  setEmailPrefs,
  updateAddress,
  updateAddressForUser,
  addAddressForUser,
  updateBillingAddress,
  forgotPassword,
  resetPassword,
  sendUnregisteredEmail,
  sendUnregisteredEmailToAll,
  deactivateUser,
  reactivateUser,
  submitContactUs,
  updateName,
  updatePhone,
  updateTitle,
  updateNhKExempt,
  resetNhKWindow,
  getUserTitles,
  getAllCuratedTitles,
  createCuratedTitle,
  updateCuratedTitle,
  deleteCuratedTitle,
  updateMyPhone,
  updateUserBalances,
  getBulkUpdateJobStatus,
  getBulkUsersPage,
  updateUsernameEmail,
  getAddresses,
  getAddressesForUser,
  searchSubsiteUsers,
  addAddress,
  removeAddress,
  updateBalanceRollsOver,
  getSubsiteAdmins,
  getEmailHistory,
  getCapabilities,
  setCapabilities,
  getProductCapabilities,
  setProductCapabilities,
  getCapabilityDetails,
  setCapabilityLogo,
  setCapabilityColor,
  getCapabilityRestrictions,
  getLogoCapability,
  setLogoCapability,
  getColorCapability,
  setColorCapability,
  getUserSubsites,
  searchAllUsers,
  getSuperUserDetails,
  getScheduledBalances,
  deleteScheduledBalance

};

export default UserService;